import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import ToggleButton from '@material-ui/lab/ToggleButton';
import Tooltip from '@material-ui/core/Tooltip';
import MenuItem from '@material-ui/core/MenuItem';

import AddIcon from '@material-ui/icons/Add';
import CheckIcon from '@material-ui/icons/Check';

const useStyles = makeStyles({
    productItem: {
        padding: '10px 20px 10px 15px',
        border: '0px solid #D2D2D8',
        borderBottom: '1px solid #D2D2D8',
        width: 260,
        marginBottom: 0,
        '& .MuiOutlinedInput-root':{
            height:30
        },
        '&:last-child': {
            borderBottom: 0
        }
    },
    productLabel:{
        marginBottom: 10,
    },
    productFormat:{
        minWidth: 100
    },
    textItemFont:{
        fontSize:11
    },
    productSelectButton: {
        marginLeft: 20,
        marginTop: 5,
        '& .Mui-selected':{
            color:'#fff',
            background:'#0C4C35'
        }
    },

});

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }))(Tooltip);

export default function DataProductCard(props) {
  const classes = useStyles();
  const [selected, setSelected] = useState(props.selected);
  const [format, setFormat] = useState(props.defaultFormat);

  /*
  useEffect(() => { 
    console.log("product:" + props.productid);
    //props.handleSelect(props.productid);
  },[])
  */

  useEffect(() => { 
    props.handleSelect(props.productid, selected, format);
  },[selected, format])

  return (
    <div className={classes.productItem}>
        <Grid container>
            <Grid item xs={9}>
                <Grid container>
                    <Grid item xs={12}><Box className={classes.productLabel} fontWeight="fontWeightBold" fontSize={12}>{props.product}</Box></Grid>
                    <Grid item xs={8}>
                        <TextField value={format} className={classes.productFormat} InputProps={{classes: {input: classes.textItemFont}}} id="format" label="format" variant="outlined" size="small" disabled={!props.disabled} onChange={e => setFormat(e.target.value)} select> 
                            {props.formats.map((item, i) =>
                                <MenuItem key={i} value={item.value}>{item.label}</MenuItem>
                            )}
                        </TextField>
                    </Grid>
                    <Grid item xs={4}><Box justifyContent="center" alignItems="center" fontWeight="fontWeightBold" fontSize={12}>£{props.price}</Box></Grid>
                </Grid>
            </Grid>
            <Grid item xs={3}>
                <Box className={classes.productSelectButton} >
                <HtmlTooltip title={<React.Fragment>{props.tooltip}</React.Fragment>}>
                    <span><ToggleButton className={classes.editButton} value="selected" selected={selected} disabled={!props.disabled} onChange={() => {setSelected(!selected)} } > {selected ? ( <CheckIcon />) : ( <AddIcon /> )} </ToggleButton></span>
                </HtmlTooltip>
                </Box>
            </Grid>
        </Grid>
    </div>

  );
}
